import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';
import { NumberExistError, WrongNumberError } from './errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const changeNumberUrl = (oldPhoneNumber) => (
  `${api_config.bet_tracker_api}/phonenumber/${oldPhoneNumber}`
);

// eslint-disable-next-line import/prefer-default-export
export const postChangeNumber = (oldPhoneNumber, newPhoneNumber) => (
  fetch(changeNumberUrl(oldPhoneNumber), {
    method: 'POST',
    headers: POST_HEADERS,
    body: JSON.stringify({ newphonenumber: newPhoneNumber }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 400: {
          throw new WrongNumberError(statusText, status);
        }
        case 412: {
          throw new NumberExistError(statusText, status);
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
